import { Button, CellSimple, EllipsisText } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellSimpleEllipsizedTitleExample = {
  title: "CellSimple - Ellipsized title",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [],

  Preview() {
    return (
      <CellSimple
        after={<Button key="icon" variant="secondary" size="small">Открыть</Button>}
        before={<PlaceholderIcon />}
        height="normal"
        subtitle="Подпись тоже очень длинная, но в этом примере она будет выводиться полностью"
        title={<EllipsisText>Я — ячейка с очень длинным заголовком, поэтому люди не смогут дочитать меня до конца</EllipsisText>}
      />
    )
  },

  getCode() {
    return `<CellSimple
  after={<Button key="icon" variant="secondary" size="small">Открыть</Button>}
  before={<Icon24Placeholder />}
  height="normal"
  subtitle="Подпись тоже очень длинная, но в этом примере она будет выводиться полностью"
  title={<EllipsisText>Я — ячейка с очень длинным заголовком, поэтому люди не смогут дочитать меня до конца</EllipsisText>}
/>`
  },
}